<template>
  <div
    class="scmcc-sidebar theme-bg-darkness-color"
    :class="{ 'scmcc-sidebar-fold': $store.state.main.sidebar.fold }"
  >
    <div class="scmcc-sidebar-wrapper">
      <CLogo @click="goHome" :type="$store.state.main.sidebar.fold && 'mini'" />
      <CMenu
        :data="$store.state.main.menus.selected"
        :width="232"
        :item-height="48"
        :fold-width="64"
        :type="$store.state.main.sidebar.fold ? 'fold' : 'unfold'"
        @on-click="onClickMenu"
      ></CMenu>
    </div>
  </div>
</template>
<script>
import CLogo from './CLogo'
import CMenu from './Menu/'
import envConst from '../env-const'
import { stringify } from 'qs'
export default {
  name: 'sidebar',
  data(){
    return {
      envConst
    }
  },
  components: {
    CLogo,
    CMenu
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'home' })
    },
    onClickMenu(menu) {
      let query = {tab_id: menu.id}
      if (menu.type === 'external') {
        //判断是否是智能应答
        if (menu.id === "200003") {
            //调智能应答接口拿到参数;
            this.$http.get('/sctm/sctmtenantinfos/intelligenceResponseUserKey').then(res =>{
              // debugger;
              if(res.data.returnCode == 0){
                query.externalSrc = `${menu.params.externalSrc}?${stringify(
                res.data.bean
                )}`
                console.log("query",query);
                if (menu.parentMenu) query.parents = menu.parentMenu.id;
                let selects = this.$store.state.main.menus.selected
                for(let i = 0;i<selects.length;i++){
                  if(selects[i].id === "200003"){
                    selects[i].params.externalParams = res.data.bean
                  }
                }
                console.log(selects)
                this.$router
                  .push({
                    path: menu.path,
                    query
                  })
                  .catch(err => {
                    console.warn(err.message)
                  });
                  return
              } else{
                this.$Message.error(res.data.returnMessage);
                return
              }
            })
            return
        }else {
          query.externalSrc = `${menu.params.externalSrc}?${stringify(menu.params.externalParams)}`
        }
        console.log("query.externalSrc",query.externalSrc);

        if (menu.target === 'blank') {
          if (menu.id === '60011') {
            this.$http.get('/sctm/sctmtenantinfos/informationPlatformUserKey').then(res =>{
              if(res.data.returnCode == 0){
                let url = menu.params.externalSrc + '?secretKey=' + res.data.bean;
                console.log("url", url)
                window.open(url);
              } else{
                this.$Message.error(res.data.returnMessage);
              }
            })
          } else {
            window.open(query.externalSrc);
          }
          // return window.open(query.externalSrc)
          return
        }
        if (menu.parentMenu) query.parents = menu.parentMenu.id
      } else if (menu.type === 'custom') {
        if (menu.parentMenu) query.parents = menu.parentMenu.id
      } else if (menu.type === 'object') {
        query.objectId = menu.params.objectId
        query.objectName = menu.params.objectName
        query.tab_title = menu.params.tab_title
        query.layoutId = menu.params.layoutId
        if (menu.parentMenu) query.parents = menu.parentMenu.id
      }
      console.log("menu",menu);
      this.$router
        .push({
          path: menu.path,
          query
        })
        .catch(err => {
          console.warn(err.message)
        })
    }
  }
}
</script>

<style lang="stylus">
.scmcc-sidebar
  flex none
  width 232px
  transition all 0.3s
  overflow hidden

  &.scmcc-sidebar-fold
    flex none
    width 64px
    overflow visible
    position relative
    z-index 1

  .scmcc-sidebar-wrapper
    display flex
    flex-flow column
    height 100%
</style>
